
interface FeedbackPayload {
  ChatId: string;
  liked: boolean;
  disliked: boolean;
  feedback: string;
}

function getAuthHeaders(): Record<string, string> | null {
  const token = localStorage.getItem('authToken');
  if (!token) return null;
  return { Authorization: `Bearer ${token}` };
}

export async function submitFeedback(payload: FeedbackPayload): Promise<void> {
  const headers = getAuthHeaders();
  if (!headers) return;

  await fetch(`${process.env.REACT_APP_Auth_Url}/api/MomentumAMP/feedback`, {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}
